import DialogClose from "atoms/DialogClose/DialogClose";
import { Missions } from "hooks/Missions/Missions";
import SlidingDialog from "hooks/SlidingDialog";
import { useDispatch, useSelector } from "react-redux";
import { formOpenSelector, setFormOpen } from "reducers/rhapsody";

/**
 *
 * @returns {ReactElement} MissionsFullScreen page
 */
export function MissionsFullScreen() {
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setFormOpen({ isOpen: false, formID: "missions" }));
  };
  const open = useSelector(formOpenSelector("missions"));

  return (
    <SlidingDialog open={open} onClose={handleClose}>
      <Missions />
    </SlidingDialog>
  );
}
